import React, { Component } from "react";

import "./styles.css";

export default class CadContainer extends Component {
  /** Bloco estilizado para cada parte do formulário */
  render() {
    return (
      <div className="cad__container">
        <div className="cad__title">{this.props.title}</div>
        <div className="cad__children">{this.props.children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Sancor/Cadastro/CadContainer/index.js